const GroupRoleEnum = Object.freeze({
  GROUP_OWNER: 'group-owner',
  GROUP_MEMBER: 'group-member'
});

export default GroupRoleEnum;
